// import { Validator } from 'vee-validate';
import Utility from '@/common/UtilityFunctions.js';
import RequestService from '@/common/requestService';
import { ApiResponse } from '@/interfaces/RequestService';
import ApiResponseResultModel from '@/interfaces/ApiResponseResultModel';
import DmrLookupResponseModel from '@/interfaces/DmrLookupResponseModel';

// export const licensePlateExists = {
//   getMessage: (): string => 'Registreringsnummer kunne ikke findes',
//   async validate(value: string): Promise<boolean> {
//     if (value.length < 3) {
//       return false;
//     }

//     value = value.toUpperCase().replace(/\s/g, '');
//     const url = encodeURI(Utility.constants().API.claimDmrLookup + value);

//     return RequestService.get<ApiResponseResultModel<DmrLookupResponseModel>>(url)
//       .then((response: ApiResponse<ApiResponseResultModel<DmrLookupResponseModel>>) => {
//         // if IsSuccess is true we assume that DMR is online
//         if (response.data.IsSuccess) {
//           if (response.data.Data) {
//             return response.data.Data.ExistsInDMR;
//           }
//         }

//         return !response.data.IsSuccess;
//       })
//       .catch((err: string) => {
//         Utility.logError(err, 'license_plate_exists');
//         return false;
//       });
//   }
// };

// export default Validator.extend('license_plate_exists', licensePlateExists);

import { defineRule } from 'vee-validate';

// Standalone async validation function
async function validateLicensePlate(value: string) {
  if (!value) {
    return true; // Skip licenseplate validation if none has been provided
  }

  if (value.length < 3) {
    return 'Registreringsnummer kunne ikke findes'; // Validation fails if length is less than 3
  }

  value = value.toUpperCase().replace(/\s/g, '');
  const url = encodeURI(Utility.constants().API.claimDmrLookup + value);

  try {
    const response = await RequestService.get<ApiResponseResultModel<DmrLookupResponseModel>>(url);
    if (response.data.IsSuccess) {
      if (response.data.Data && response.data.Data.ExistsInDMR) {
        return true; // Validation succeeds
      }
    }
    return 'Registreringsnummer kunne ikke findes'; // Specific failure message
  } catch (err) {
    Utility.logError(err, 'license_plate_exists');
    return 'Registreringsnummer kunne ikke findes'; // Failure message for exceptions
  }
}

export default validateLicensePlate;

// Define the rule with the standalone function
// defineRule('license_plate_exists', validateLicensePlate);
